import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, filter, map, take } from 'rxjs/operators';
import { AuthCheckService } from '../services/auth-check.service';
import { DadosLoginService } from '../services/dados-login.service';
import { PermissionService } from '../services/permission.service';

export const permissionGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const permissionService = inject(PermissionService);
    const dadosLoginService = inject(DadosLoginService);
    const authCheckService = inject(AuthCheckService);

    if (!authCheckService.isLogged) {
        router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }

    return dadosLoginService.dadosLogin$.pipe(
        filter(dadosLogin => dadosLogin !== null),
        take(1),
        map(() =>
            checkPermissions(permissionService, router, route.data, state)
        ),
        catchError(error => {
            console.error('Erro no carregamento de permissões:', error);
            router.navigate(['/login'], {
                queryParams: { returnUrl: state.url },
            });
            return of(false);
        })
    );
};

function checkPermissions(
    permissionService: PermissionService,
    router: Router,
    routeData: any,
    state: any
): boolean {
    const { permissions, dominio } = routeData;

    if (
        permissions &&
        !permissionService.hasAnyPermission(permissions, dominio)
    ) {
        const isInitialNav = !router.getCurrentNavigation()?.previousNavigation;
        router.navigate(['/pages/access-denied'], {
            queryParams: {
                path: state.url,
                permissions: permissions.join(','),
                initial: isInitialNav ? '1' : undefined,
            },
            replaceUrl: !!isInitialNav,
        });
        return false;
    }

    return true;
}
